/**
 * @file gcp 机房特殊的一些配置文件
 * @author laixiang (laixiang@bytedance.com)
 *
 */
const REGION_CONFIG = {
  VA: 'VA',
  SG: 'SG',
  IN: 'IN',
};


const region = process.env.REGION || '';

// 是否是印度 gcp 机房
export const isIndia = region === 'IN';
// 是否 sg
export const isSg = region === 'SG';

export const zone = REGION_CONFIG[region] || 'SG';

// ImageX平台模版名称
export const IMAGE_X_IMG_TEMPLATE = {
  ORIGIN: '~tplv-n82rq3yc7r-origin.image', // 原图
  COMPRESS_WEBP: '~tplv-n82rq3yc7r-compress.webp', // webp格式压缩
  COMPRESS_IMAGE: '~tplv-n82rq3yc7r-compress.image', // image默认压缩
  BOE_I18N: '~tplv-1np7q8yqs1-image.image', // BOE环境模版
};

// gcp 印度地区的 sso 相关一系列配置
// reference: https://bytedance.feishu.cn/docs/doccntxsWvMdODJ0XeqT624rqOe#
export const GCP_SSO_HOST = 'in-business-sso.tiktok.com';
export const GCP_SSO_URL = `https://${GCP_SSO_HOST}/`;
export const GCP_SSO_LOGOUT = `https://${GCP_SSO_HOST}/logout/`;
